module.exports = __webpack_public_path__ + "static/displacer_beast-a55597e9dbb4c8ccd8cf20706d9bae06.jpeg";